<template>
 <div>
  <Header />
  <div class="cooperationMode-content">
   <div class="cooperationMode-content-title cooperationMode_box">应用搭建服务-基于畅图云与用户需求</div>
   <div class="cooperationMode-content-jianjie cooperationMode_box">
    提供轻应用搭建服务，包括三维建模、UI设计、交互设计等设计服务，以及物联网数据对接、数据业务流转、数据分析、数字孪生等应用搭建服务，快速完成业务应用场景搭建，比如安全监测、物联网、大屏展示等。
   </div>
   <div class="cooperationMode-content-content">
    <div class="cooperationMode-content-content-left ">
     <div class="cooperationMode-content-content-left-box cooperationMode_box">
      <span class="cooperationMode-content-content-left-title">多</span>
      <span>丰富的模版和应用搭建经验</span>
     </div>
     <div class="cooperationMode-content-content-left-box cooperationMode_box">
      <span class="cooperationMode-content-content-left-title">快</span>
      <span>最快48小时完成搭建</span>
     </div>
     <div class="cooperationMode-content-content-left-box cooperationMode_box">
      <span class="cooperationMode-content-content-left-title">好</span>
      <span>易用性强、交互性好、展示美观</span>
     </div>
     <div class="cooperationMode-content-content-left-box cooperationMode_box">
      <span class="cooperationMode-content-content-left-title">省</span>
      <span>10000¥起、公有云免费</span>
     </div>
    </div>
    <div class="cooperationMode-content-content-right cooperationMode_box">
     <img src="@/assets/image/companyProfile/cooperation.png" alt="">
    </div>
   </div>
  </div>
  <div class="cooperationMode-content-mobile">
   <div class="cooperationMode-content-mobile-title cooperationMode_box">
    <div class="cooperationMode-content-title-content-mobile ">应用搭建服务-基于畅图云与用户需求</div>
    <div>提供轻应用搭建服务，包括三维建模、UI设计、交互设计等设计服务，以及物联网数据对接、数据业务流转、数据分析、数字孪生等应用搭建服务，快速完成业务应用场景搭建，比如安全监测、物联网、大屏展示等。
    </div>
   </div>
   <div class="cooperationMode-content-content-mobile">
    <div class="cooperationMode-content-content-mobile-item">
     <span class="cooperationMode-content-content-mobile-item-left">多</span>
     <span class="cooperationMode-content-content-mobile-item-right">丰富的模版和应用搭建经验 </span>
    </div>
    <div class="cooperationMode-content-content-mobile-item">
     <span class="cooperationMode-content-content-mobile-item-left">快</span>
     <span class="cooperationMode-content-content-mobile-item-right">最快48小时完成搭建 </span>
    </div>
    <div class="cooperationMode-content-content-mobile-item">
     <span class="cooperationMode-content-content-mobile-item-left">好</span>
     <span class="cooperationMode-content-content-mobile-item-right">易用性强、交互性好、展示美观 </span>
    </div>
    <div class="cooperationMode-content-content-mobile-item">
     <span class="cooperationMode-content-content-mobile-item-left">省</span>
     <span class="cooperationMode-content-content-mobile-item-right">10000¥起、公有云免费 </span>
    </div>
   </div>
   <div class="cooperationMode-content-content-mobile-bottom cooperationMode_box">
    <img src="@/assets/image/companyProfile/cooperationMobile.png" alt="" style="width: 100%;">
   </div>
  </div>
 </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import Header from "./header.vue"
import ScrollReveal from 'scrollreveal'


onMounted(() => {
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 300,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".cooperationMode_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .cooperationMode-content {
  display: none !important;
 }

 .cooperationMode-content-mobile {
  display: block;
 }
}

@media screen and (min-width: 800px) {
 .cooperationMode-content {
  display: block !important;
 }

 .cooperationMode-content-mobile {
  display: none;
 }
}

.cooperationMode-content {
 padding-left: 18%;
 padding-right: 18%;
 font-family: 'PuHuiTi';
}

.cooperationMode-content-mobile {
 font-family: 'PuHuiTi';
}

.cooperationMode-content-title-content-mobile {
 background: url("../../../assets/image/product/Line.png") no-repeat;
 font-size: 18px;
 height: 28px;
 font-family: 'PuHuiTi';
 background-position: 0px 18px;
 margin-bottom: 10px;
 padding-left: 6px;
}

.cooperationMode-content-title {

 margin: 30px 0;
 background: url("../../../assets/image/product/Line.png") no-repeat;
 background-position: 0px 18px;
 padding-left: 10px;
 color: rgba(51, 51, 51, 1);
 font-size: 24px;
}

.cooperationMode-content-jianjie {
 margin-bottom: 30px;
}

.cooperationMode-content-content {
 width: 100%;
 margin-top: 10px;
 margin-bottom: 150px;
 display: flex;
 justify-content: space-between;
 align-items: center;
 height: 260px;
}

.cooperationMode-content-content-left {
 height: 100%;
 display: flex;
 flex-direction: column;
 justify-content: space-around;
 align-items: flex-start;

}


.cooperationMode-content-content-left-box {
 display: flex;
 align-items: center;
}

.cooperationMode-content-content-left-title {
 color: rgba(32, 129, 235, 1);
 font-size: 24px;
 font-weight: 700;
 margin-right: 5px;
}

.cooperationMode-content-mobile-title {
 padding: 10px 20px;
 line-height: 2;
}

.cooperationMode-content-content-mobile {
 padding: 10px 20px;
}

.cooperationMode-content-content-mobile-item {
 margin-bottom: 10px;
 display: flex;
 align-items: center;
}

.cooperationMode-content-content-mobile-item-left {
 color: rgba(32, 129, 235, 1);
 font-size: 24px;
 font-weight: 700;
 margin-right: 5px;
}

.cooperationMode-content-content-mobile-bottom {
 width: 100%;
 padding: 10px 30px;
 margin-bottom: 10px;
}
</style>